import { BasketContact } from 'components/ordering/acl/internal-types.js'
import { equals } from 'typia'


export const parseBasketContactForm = (form: HTMLFormElement): BasketContact => {
  const basketContact = Object.fromEntries(new FormData(form).entries())

  if (equals<BasketContact>(basketContact)) {
    return basketContact
  }

  throw new Error('Error parsing csc-basket-contact form')
}
